import { Component } from "@angular/core";

@Component({
  selector: "custom",
  template: "<router-outlet></router-outlet>"
})
export class CustomComponent {
  constructor() { }
}
